import {
  Combobox,
  ComboboxContent,
  ComboboxEmpty,
  ComboboxItem,
  ComboboxList,
  ComboboxOption,
  ComboboxSearch,
  ComboboxTrigger,
} from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

/** Mehrfachauswahl mit Chips im Feld (V2-Combobox), z. B. für Erinnerungen. */
export function MultiSelectV2({
  id,
  invalid = false,
  options,
  values,
  onChange,
  title,
}: {
  id?: string;
  invalid?: boolean;
  options: ComboboxOption[];
  values: string[];
  onChange: (values: string[]) => void;
  /** Titel im Mobile-Drawer. */
  title: string;
}) {
  const { t } = useTranslation();
  // Nur Werte anzeigen, die es als Option gibt (z. B. nach Datumswechsel).
  const selectedValues = values.filter((value) =>
    options.some((option) => option.value === value),
  );

  return (
    // `modal`: liegt im Sheet, sonst scrollt die Liste nicht per Mausrad.
    <Combobox
      modal
      multiple
      options={options}
      value={selectedValues}
      onValueChange={onChange}>
      <ComboboxTrigger
        wrap
        id={id}
        aria-invalid={invalid}
        placeholder={t('actions.auswaehlen')}
      />
      <ComboboxContent
        align="start"
        className="md:w-(--radix-popover-trigger-width)"
        title={title}
        doneLabel={t('actions.fertig')}>
        <ComboboxSearch
          placeholder={t('domain.mitarbeiter.rotationsplan.filter.suchen')}
        />
        <ComboboxList>
          <ComboboxEmpty
            title={t('domain.mitarbeiter.rotationsplan.filter.keineErgebnisse')}
          />
          {options.map((option) => (
            <ComboboxItem key={option.value} option={option} />
          ))}
        </ComboboxList>
      </ComboboxContent>
    </Combobox>
  );
}
